// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separator {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
}

.purpose {
  text-align: justify;
  margin: auto;
  border-radius: 12px;
}

.cardd {
  text-align: justify;
  padding: 10px;
}

.divider {
  z-index: 0;
  position: relative;
  height: 2px;
  background-color: #F16278;
  display: block;
  margin: auto;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.scss"],"names":[],"mappings":"AAGA;EACC,kBAAA;EACA,iBAAA;EACG,oBAAA;AAFJ;;AAMA;EACC,mBAAA;EAEG,YAAA;EACA,mBAAA;AAJJ;;AAOA;EACC,mBAAA;EAEG,aAAA;AALJ;;AAOA;EACC,UAAA;EACG,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EAEA,YAAA;EACA,kBAAA;AALJ","sourcesContent":["@import \"../../scss/colors\";\n@import \"../../scss/globals\";\n\n.separator{\n\ttext-align: center;\n\tpadding-top: 30px;\n    padding-bottom: 30px;\n}\n\n\n.purpose{\n\ttext-align:justify;\n\t// max-width: 600px;\n    margin: auto;\n    border-radius: 12px;\n}\n\n.cardd{\n\ttext-align:justify;\n\t// max-width: 600px;\n    padding:10px;\n}\n.divider{\n\tz-index: 0;\n    position: relative;\n    height: 2px;\n    background-color:#F16278;\n    display: block;\n    // margin-top: -12px;\n    margin: auto;\n    text-align: center;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
